export default __webpack_public_path__ + "static/media/post-suvinil1.21402214.png";